<!--
 * @Description: 供应商评价
 * @Author: wangwangwang
 * @Date: 2020-12-01 11:47:46
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-12-21 17:08:50
-->
<template>
  <div class="flows-content">
    <el-container>
      <el-main style="margin-bottom: 20px; padding: 0;">
        <el-container direction="vertical">
          <FlowHeader :isReadOnly="readOnly" @saveSubmit="handleSubmit(1)" @sendSubmit="handleSubmit(2)" @handleBackEnd="handleSubmit(3)" @handleCC="handleSubmit(4)" @handleAssign="handleSubmit(5)" @handleBackUp="handleSubmit(6)" @handleAssist="handleSubmit(7)" @handleNode="handleSubmit(8)" @handleNodeImage="handleSubmit(9)" @handleCollection="handleSubmit(10)" />
          <el-main class="info">
            <div>
              <el-input v-model="title" class="flow-title" :disabled="$route.query.type*1!==1" placeholder="请输入流程标题"></el-input>
            </div>
            <div class="info-top">
              <div class="left">
                <span>单据号码：{{billCode}}</span>
                <span class="text">制单日期：{{billDate}}</span>
              </div>
              <div class="right">
                <span>发起人：{{applyPerson}}</span>
                <span class="text">状态：{{taskTypeText[taskStatus*1]}}</span>
              </div>
            </div>
            <div style="margin-top:20px;">
              <div class="title-title">
                <div>当前评价周期：{{ commentsData.period }}</div>
                <div>评价分值：{{ commentsData.evaluateSumScore }}</div>
              </div>
              <!-- <div style="padding:10px 0px;">
                <span style="margin-left:10px;">
                  <span slot="label">站点名称：</span>
                  <span style="padding-left:15px">{{commentsData.stationName}} </span>
                </span>
              </div> -->
              <div style="padding: 0 20px">
                <template v-for="(item, index) in commentsData.list">
                  <div :key="index">
                    <div class="dialoginfo-title">
                      <div class></div>
                      <span>{{ item.evaluateTitle }}</span>
                      <span style="color: #808080; font-size: 14px">(权重：{{ item.ratio }})</span>
                    </div>
                    <el-radio-group v-model="item.evaluateOptionId" disabled>
                      <template v-for="(item, index) in stararr">
                        <el-radio :key="index" :label="item.id">{{
                          item.text
                          }}</el-radio>
                      </template>
                    </el-radio-group>
                    <el-form label-width="70px" label-position="left" style="width: 820px; padding-top: 20px">
                      <el-form-item label="评价">
                        <el-input v-model="item.evaluateContent" disabled type="textarea" maxlength="500" :rows="5" resize="none"></el-input>
                      </el-form-item>
                    </el-form>
                  </div>
                </template>
                <div>
                  <el-checkbox v-model="commentsData.check" disabled>评价后发送给供应商</el-checkbox>
                </div>
              </div>
            </div>
            <div class="flows-details">
              <FlowContent ref="flowcontent" :title='title' :showSendVisible="showSendVisible" @handleCancel="handleCancel" @sendCode="sendCode" @handleFinish="handleFinish" @handleBusiness="handleBusiness" />
            </div>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import FlowContent from '@/components/WorkFlow/flowContent';
import FlowHeader from '@/components/WorkFlow/flowHeader';
import { queryIsEvaluat } from "@/api/GHnumber/supplier.js";
import { getUserInfo } from "@/utils/auth.js";
export default {
  components: {
    FlowContent,
    FlowHeader,
  },
  data() {
    return {
      type: 0,
      title: '供应商评价',
      billCode: '',
      billDate: '',
      applyPerson: '',
      taskTypeText: ['发起', '已保存', '审批中', '已完成', '撤销', '不通过'],
      taskStatus: 0,
      showSendVisible: false,
      readOnly: false,
      formData: {},
      commentsData: {
        list: []
      },
      stararr: [
        { id: 0, text: "差评（0分）" },
        { id: 40, text: "一星（40分）" },
        { id: 55, text: "二星（55分）" },
        { id: 70, text: "三星（70分）" },
        { id: 85, text: "四星（85分）" },
        { id: 100, text: "五星（100分） " },
      ],
    }
  },
  methods: {
    handleBusiness() {
      const { query } = this.$route;
      const data = JSON.parse(query.dataContent);
      data.list = JSON.parse(data.list);
      delete data.id;
      const params = {
        process_success: {
          url: '/icps/system/sign/dataCollection/supplierEvaluate/save',
          data: {
            ...data,
          },
          httpMethod: 'post',
        },
        process_failure: ''
      }
      this.showSendVisible = false;
      this.$refs.flowcontent.handleToFlow(params);
    },
    /**
     * @Description: 
     * @Param: 1为保存，2为最后提交/3 中间提交
     * @Author: wangwangwang
     * @param {*} type
     */
    handleFinish() {
    },
    handleSubmit(type) {
      const { query } = this.$route;
      if (query.type * 1 === 2 && type === 2 && query.taskType * 1 !== 2) { // 发起流程
        this.showSendVisible = true;
        return
      }
      const data = {
        dataSource: 'SupplierRating',
        dataContent: JSON.stringify({ ...this.formData }), // 业务数据
      }
      this.$refs.flowcontent.saveFlows(type, data);
    },
    handleFlowChat() {
      this.$refs.flowcontent.showFlowNode()
    },
    handleCancel() {
      this.showSendVisible = false;
    },
    /**
     * @Description: 回显业务数据
     * @Param: 
     * @Author: wangwangwang
     */
    initFlowsData(data) {
      this.formData = data;
      queryIsEvaluat({ supplierId: data.id }).then((res) => {
        this.commentsData.period = res.data.period;
      });
      this.commentsData.evaluateSumScore = data.evaluateSumScore;
      this.commentsData.stationName = data.stationName;
      this.commentsData.check = data.pushStatus * 1 === 1;
      this.commentsData.list = JSON.parse(data.list);
    },
    initFlowsData2() {
      const { query } = this.$route;
      const data = JSON.parse(query.dataContent);
      this.title = query.taskName;
      this.billCode = query.receiptNumber;
      this.billDate = query.createTime;
      this.applyPerson = query.createUserName;
      this.taskStatus = query.taskStatus;
      queryIsEvaluat({ supplierId: data.id }).then((res) => {
        this.commentsData.period = res.data.period;
      });
      this.commentsData.evaluateSumScore = data.evaluateSumScore;
      this.commentsData.stationName = data.stationName;
      this.commentsData.check = data.pushStatus * 1 === 1;
      this.commentsData.list = JSON.parse(data.list);
    },
    sendCode(code) {
      this.billCode = code;
    },
  },
  mounted() {
    const { query } = this.$route;
    if (query.type * 1 === 1) { // 发起流程
      this.initFlowsData(query);
      this.$refs.flowcontent.initBaseData('SupplierRating');
      this.billDate = new Date().Format('yyyy-MM-dd hh:mm:ss');
      this.applyPerson = getUserInfo().userRealName;
      return
    }
    this.initFlowsData2();
    if (query.isReadOnly*1===1) {
      this.readOnly = true;
    }
  }
}
</script>
<style lang="scss" scoped>
.flows-details {
  margin-top: 20px;
}
.info {
  padding: 0 20px;
  background: #fff;
  .info-top {
    font-size: $font_size;
    color: #000000;
    @include discen_al;
    justify-content: space-between;
    height: 50px;
    border-bottom: 1px #e1e5ed solid;
    .left {
      @include discen_al;
    }
    .text {
      margin-left: 60px;
    }
  }
}
.nav_title {
  @include discen_al;
  align-items: flex-end;
  > div {
    width: 4px;
    height: 24px;
    background: $bg_color;
    margin-right: 10px;
  }
  i {
    margin-left: 5px;
  }
  color: $bg_color;
  font-size: 20px;
  font-weight: bold;
}
.title-title {
  @include discen_al;
  justify-content: space-between;
  font-size: 16px;
  font-weight: bold;
  color: #000000;
  line-height: 40px;
  .color {
    color: $bg_color;
  }
}
.el-radio {
  line-height: 45px;
}
.dialoginfo-title {
  display: flex;
  align-items: center;
  height: 50px;
  > div {
    width: 4px;
    height: 20px;
    background: $bg_color;
  }
  > span {
    padding-left: 10px;
    font-size: 20px;
    color: $bg_color;
    font-weight: 600;
  }
}
.table_link {
  margin-left: 10px;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.7;
}
.el-input,
.el-select {
  width: 200px;
}
.dialoginfo {
  .el-input,
  .el-select {
    width: 280px;
  }
}
.dialogOtherinfo {
  .el-input,
  .el-select {
    width: 310px;
  }
}
.checkcycdialoginfo {
  .el-input {
    width: 100px;
  }
  .el-select {
    width: 100px;
    margin-right: 20px;
  }
  .text {
    padding: 10px;
  }
}
</style>
